import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SUPPORTED_LANGUAGES } from '@global/constants';

/**
 * This service will be created per module to manage the module's TranslateService
 */
@Injectable({
  providedIn: 'any',
})
export class LanguageService {
  get onLangChange() {
    return this.translateService.onLangChange;
  }

  get onTranslationChange() {
    return this.translateService.onTranslationChange;
  }

  get currentLang() {
    return this.translateService.currentLang;
  }

  constructor(private readonly translateService: TranslateService) {
    this.initializeTranslateService();
  }

  initializeTranslateService() {
    this.updateLanguage();
  }

  public get(key: string | string[], interpolateParams?: Record<string, any>) {
    return this.translateService?.get(key, interpolateParams);
  }

  public stream(key: string | string[], interpolateParams?: Record<string, any>) {
    return this.translateService?.stream(key, interpolateParams);
  }

  public instant(key: string | string[], interpolateParams?: Record<string, any>) {
    return this.translateService?.instant(key, interpolateParams);
  }

  private readonly updateLanguage = () => {
    this.translateService.currentLang = '';
    this.translateService.use(
      SUPPORTED_LANGUAGES.some(l => l === navigator.language) ? navigator.language : this.translateService.defaultLang
    );
  };
}
